var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"widget_input",attrs:{"type":_vm.type,"disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"change":_vm.onChange,"blur":_vm.onBlur,"focus":_vm.onFocus,"keyup":_vm.onKeyup,"keydown":_vm.onKeydown,"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }